// extracted by mini-css-extract-plugin
export default {"button":"CategoryButton-module__button___T+hJQ","buttonIcon":"CategoryButton-module__buttonIcon___9L6d1","open":"CategoryButton-module__open___hQw2T"};